import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { DataNotFoundPage } from '@data/pages/DataNotFoundPage/DataNotFoundPage';
import { DataIssuePage } from '@data/pages/DataIssuePage/DataIssuePage';

/**
 * The status a routing error carries, however it was raised.
 *
 * A Response thrown from a loader is converted by the router into its own
 * error-response shape, which `isRouteErrorResponse` recognises. A Response
 * thrown from a component render is handed over untouched, so it fails that
 * check despite meaning exactly the same thing — hence both are read here.
 */
function errorStatus(error: unknown): number | undefined {
  if (isRouteErrorResponse(error)) return error.status;
  if (error instanceof Response) return error.status;
  return undefined;
}

/**
 * Error boundary for /data routes.
 * - 404 responses (invalid route, unknown product, etc.) → DataNotFoundPage
 * - Any other error (network failure, API 500, etc.) → DataIssuePage
 */
export function DataErrorBoundary() {
  const error = useRouteError();

  if (errorStatus(error) === 404) {
    return <DataNotFoundPage />;
  }

  return <DataIssuePage />;
}
